import React, { useRef } from 'react';
var VeltMultiThreadCommentDialogNewThreadButton = function (props) {
    var annotationId = props.annotationId, multiThreadAnnotationId = props.multiThreadAnnotationId, defaultCondition = props.defaultCondition, children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-multi-thread-comment-dialog-new-thread-button", { ref: ref, "annotation-id": annotationId, "multi-thread-annotation-id": multiThreadAnnotationId, "default-condition": [true, false].includes(defaultCondition) ? (defaultCondition ? 'true' : 'false') : undefined }, children));
};
export default VeltMultiThreadCommentDialogNewThreadButton;
